module.exports = __webpack_public_path__ + "static/media/icon5.4052cd35.jpeg";